module.exports = __webpack_public_path__ + "img/csr_111123_B.864ba547.jpg";